// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

var Types = {};

function unwrap_fragment(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
              "PropertyBroadcastAllowed",
              "PropertyBroadcastNotAllowed"
            ]);
}

var fragmentConverter = {"__root":{"PropertyBroadcastAllowed_priceCondition_requiredUntil":{"b":""},"":{"u":"fragment"}}};

var fragmentConverterMap = {
  fragment: unwrap_fragment
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

function broadcastNotAllowedReason_decode($$enum) {
  if ($$enum === "ARCHIVED" || $$enum === "REMOVED") {
    return $$enum;
  }
  
}

function broadcastNotAllowedReason_fromString(str) {
  return broadcastNotAllowedReason_decode(str);
}

var Utils = {
  broadcastNotAllowedReason_decode: broadcastNotAllowedReason_decode,
  broadcastNotAllowedReason_fromString: broadcastNotAllowedReason_fromString
};

var node = {
  "kind": "InlineDataFragment",
  "name": "PropertyWizardFormRelayBroadcastPolicy_policy"
};

var wrap_fragment = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment = unwrap_fragment;
exports.wrap_fragment = wrap_fragment;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
